export default __webpack_public_path__ + "static/media/1888.afd01411.png";